import { fetchPersea } from "@/config/axios/config-axios";
import { RedeemGiftPost } from "@/types/redeem-gift/redeem-gift";


export const postRedeemGift = async (body: RedeemGiftPost) => {
  return await fetchPersea(`campaign/benefit/exchange/claim`, 'POST', {}, body);
};